import { render } from "./PdfTemplates.vue?vue&type=template&id=2fe1af06&ts=true"
import script from "./PdfTemplates.vue?vue&type=script&lang=ts"
export * from "./PdfTemplates.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__